import { FC } from 'react';
import LogoIcon from '@/assets/logo.svg';
import { SVGComponent } from '@/types/svg-component';
import { cx } from '@/utils/cx';

export type SidebarHeadProps = {
  className?: string;
  Icon?: SVGComponent;
  iconClassName?: string;
  title?: string;
  titleClassName?: string;
};

export const SidebarHead: FC<SidebarHeadProps> = ({
  className,
  Icon = LogoIcon,
  iconClassName,
  title,
  titleClassName,
}) => (
  <div
    className={cx(
      'flex flex-row items-center gap-4 py-4',
      title && 'border-b border-gray-800',
      className,
    )}
  >
    <Icon className={cx('h-7 w-7', iconClassName)} />
    {title && (
      <div className={cx('text-2xl font-extrabold', titleClassName)}>
        {title}
      </div>
    )}
  </div>
);
